import { observer } from "mobx-react";
import BillingTransactionStore from "../../stores/billing-transaction-store";
import ProcessingIndicator from "./processing-indicator/processing-indicator";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import {FONT_COLOR, FONT_VARIANT} from "../../../../components/fonts/font-props";
import {getPartnerLogo} from "./details-modal";
import {Note, NOTE_TYPE} from "../../../../components/note/note";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import FontBody4 from "../../../../components/fonts/font-body4/font-body4";
import {PLAN_CHARGE_TYPES} from "../../../manage-subscription-plans/stores/subscription-plan-editor-store";
import {Badge, BadgeType} from "../../../../components/badge/badge";
import BillingDetailsContentRow from "./layouts/billing-details-content-row/billing-details-content-row";

interface IChildModalContent {
    transaction: BillingTransactionStore;
}

const ChildModalContent: React.FC<IChildModalContent> = observer(({ transaction }) => {

    return (
        <div className="billing-details-modal-content">
            <ProcessingIndicator isProcessing={transaction.prev_period_usages_processing} />
            <div className="content-header">
                <FontBody1 color={FONT_COLOR.NEUTRAL3}>Billing details - {transaction.month}</FontBody1>
                {transaction.partnerId && getPartnerLogo(transaction.partnerId)}
            </div>
            <Note type={NOTE_TYPE.INFORMATION} body={
                <FontBody2>
                    {`This month was paid for by ${transaction.parentBilledUser?.name}`}
                </FontBody2>}
            />

            <div className="modal-details-heading">
                <FontBody4 variant={[FONT_VARIANT.BOLD, FONT_VARIANT.UPPERCASE]} color={FONT_COLOR.PRIMARY2}>plan</FontBody4>
                <FontBody2 variant={FONT_VARIANT.BOLD}>
                    {transaction.plan_name}
                    {transaction.planType === PLAN_CHARGE_TYPES.ANNUAL && <Badge type={BadgeType.INFO} text="Annual"></Badge>}
                </FontBody2>
            </div>

            <BillingDetailsContentRow>
                <FontBody2>Used returns quota</FontBody2>
                <FontBody2 variant={FONT_VARIANT.BOLD}>{transaction.rmaCount}</FontBody2>
            </BillingDetailsContentRow>

            <BillingDetailsContentRow>
                <FontBody2>Used order tracking quota</FontBody2>
                <FontBody2 variant={FONT_VARIANT.BOLD}>{transaction.orderTrackingCount}</FontBody2>
            </BillingDetailsContentRow>

        </div>
    );
});

export default ChildModalContent
